import React, { useEffect, useState } from "react";
import { loadSection } from "../../services/contentSource";
import expertiseFallback from "../../data/home/expertise.json";

const EnterpriseExpertise = () => {
  const [data, setData] = useState<any>(expertiseFallback);

  useEffect(() => {
    loadSection("expertise", expertiseFallback as any)
      .then(({ data: main }) => {
        if (main) setData(main);
      })
      .catch((err) => {
        console.warn("Using fallback expertise data:", err);
      });
  }, []);

  if (!data) return null;

  return (
    <div className="enterprise-area mx-techstack-revamp">
      <div className="container mx-container">
        <div className="mx-techstack-inner">
          <div className="mx-techstack-label-row">
            <span className="mx-techstack-chip">TECHNOLOGY MASTERY</span>
            <h4 className="mx-techstack-title">
              {data.headerText || "Our MindSyncX Technology Expertise includes"}
            </h4>
          </div>

          <div className="mx-techstack-row">
            {(data.technologies || []).map((tech: any, index: number) => (
              <div className="mx-techstack-pill" key={index}>
                <div className="mx-techstack-icon">
                  <img className="show-light" src={tech.icon?.light} alt={`${tech.name} icon`} loading="lazy" decoding="async" />
                  <img className="show-dark" src={tech.icon?.dark} alt={`${tech.name} icon`} loading="lazy" decoding="async" />
                </div>
                <span className="mx-techstack-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnterpriseExpertise;
